export function extractCity(address: string): string | null {
  if (!address) {
    return null
  }

  const adminKeywords = [
    'departmento',
    'departamento',
    'province',
    'provincia',
    'state',
    'region',
    'county',
    'district',
    'municipio',
    'prefecture',
    'governorate',
  ]

  const parts = address
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean)

  // Walk from right to left, skipping country
  for (let i = parts.length - 2; i >= 0; i--) {
    const part = parts[i]
    const lower = part.toLowerCase()

    // Skip administrative divisions
    if (adminKeywords.some((k) => lower.includes(k))) {
      continue
    }

    // Case 1: "ZIP City" → extract City
    const zipCityMatch = part.match(/^\s*[A-Z0-9-]{3,10}\s+(.+)$/)
    if (zipCityMatch) {
      const city = zipCityMatch[1].trim()
      if (/^[A-Za-zÀ-ÿ\s'.-]{2,}$/.test(city)) {
        return city
      }
    }

    // Case 2: city-only segment
    if (/^[A-Za-zÀ-ÿ\s'.-]{2,}$/.test(part) && !/\b(de|of)\b/i.test(part)) {
      return part
    }
  }

  return null
}
